export default {
    namespaced: true,
    state: {
        mostrandoAlerta: false,
    },
    mutations: {
        SET_MOSTRANDO_ALERTA(state, valor) {
            state.mostrandoAlerta = valor
        },
    },
    actions: {
    },
    getters: {
        mostrandoAlerta: state => state.mostrandoAlerta,
    }
}